<template>
  <div>
    <api-loading :show="loading"></api-loading>
    <Sideleft
      :sideStatus="leftSideStatus"
      :distributor_name="filters.distributorName"
      :cont="filters.contact"
      @filtrate="filtrate"
      @batchSearch="batchSearch"
    />
    <div class="br-contentpanel" :data-min="leftSideStatus">
      <Header
        :batchBool="batchBool"
        :distributorName="filters.distributorName"
        :cont="filters.contact"
        :check_items="checkArr"
        @clearKey="clearKey"
      />
      <router-view
        v-if="isSysRights('SupplierProductStock.findRawSupplierList')"
        :first_loading="firstLoading"
        :items="items"
        :check_arr="checkArr"
      ></router-view>
      <no-rights v-else></no-rights>
      <Pagination
        class="pd-x-20 pd-sm-x-30"
        v-if="!firstLoading"
        :cur="page"
        :all="totalPage"
        :path="'/material-suppliers/'"
        :page_size_select="pageSizeSelect"
        :rows_per_page="rowsPerPage"
        :total_count="totalCount"
        @changeRPPage="changeRPPage"
        @gotoPage="toPage"
      />
    </div>
    <!-- 新增或修改客户弹框 -->
    <modal-didtributor
      :open="modalDidtributor.open"
      :changeinfo="modalDidtributor.info"
    />
    <!-- 导入客户信息 -->
    <modal-import-distributor :open="modalImportOpen" />
    <batch-search-dialog @handleBatchSearch="handleBatchSearch" :dialog="batchSearchDialog" v-if="batchSearchDialog.visible == true"></batch-search-dialog>
  </div>
</template>

<script>
import Sideleft from "./left-side.vue";
import Header from "./header.vue";
import { pagination } from "@components/pagination.js"; //分页
import ModalDidtributor from "./modal-didtributor.vue";
import ModalImportDistributor from "./modal-import-distributor.vue";
import BatchSearchDialog from '../distributor/batch-search-dialog.vue'

export default {
  components: {
    BatchSearchDialog,
    Sideleft,
    Header,
    Pagination: pagination,
    ModalDidtributor,
    ModalImportDistributor,
  },
  data() {
    return {
      loading: false,
      firstLoading: false,
      leftSideStatus: store.get("leftSideStatus"), //左边栏状态
      pageSizeSelect: [10, 20, 50],
      page: this.$route.params.page ? this.$route.params.page : 1,
      rowsPerPage: parseInt(store.get("MS-rowsPerPage"))
        ? parseInt(store.get("MS-rowsPerPage"))
        : 10,
      totalPage: 0,
      totalCount: 0,
      items: [],
      checkArr: [],
      filters: {
        distributorName: "",
        contact: "",
      },
      modalDidtributor: {
        open: Symbol(),
        info: {},
      },
      modalDidtributorDefault: "{}",
      modalImportOpen: Symbol(),
      batchSearchDialog:{
        visible: false,
        key: '',
      },
      batchSearchParams: {},
      batchBool: false,
    };
  },
  mounted() {
    //展开折叠搜索
    let user = store.get("userInfo");
    let that = this;
    if (this.$parent.sideTop) {
      if ($(".br-subleft").outerHeight() > 56) {
        $(".br-subleft").addClass("left-more ht-54 ht-auto");
        $(".br-subleft").append(
          `<a href="javascript:;" class="d-flex align-items-center more-btn"><span class=" mg-r-5 tx-info">${this.$t(
            "app.更多"
          )}</span><i aria-hidden="true" class="tx-info fa fa-angle-down"></i></a>`
        );
        $(".more-btn").on("click", function () {
          if ($(this).find("i").hasClass("fa-angle-down")) {
            $(this).find("span").text(that.$t("app.隐藏"));
            $(this).parent(".br-subleft").removeClass("ht-54");
            $(this)
              .find("i")
              .removeClass("fa-angle-down")
              .addClass("fa-angle-up");
          } else {
            $(this).find("span").text(that.$t("app.更多"));
            $(this).parent(".br-subleft").addClass("ht-54");
            $(this)
              .find("i")
              .addClass("fa-angle-down")
              .removeClass("fa-angle-up");
          }
          let bodyH = parseInt($(window).height());
          if (user.source == 9) {
            if ($("body").hasClass("side-top")) {
              let ht = $(".br-subleft").outerHeight();
              $(".body-wrap").css("height", bodyH - 340 - ht + "px");
            } else {
              $(".body-wrap").css("height", bodyH - 340 + "px");
            }
          } else {
            if ($("body").hasClass("side-top")) {
              let ht = $(".br-subleft").outerHeight();
              $(".body-wrap").css("height", bodyH - 260 - ht + "px");
            } else {
              $(".body-wrap").css("height", bodyH - 260 + "px");
            }
          }
        });
      }
    }
    this.getDistributor();
    this.modalDidtributorDefault = JSON.stringify(this.modalDidtributor);
  },
  methods: {
    batchSearch(key){
      this.batchSearchDialog = {
        visible: true,
        key: key
      }
    },
    handleBatchSearch(item){
      this.batchSearchParams = item
      this.batchBool = true
      this.page = 1
      this.rowsPerPage = 10
      this.getDistributor()
    },

    //todo
    getDistributor(batch) {
      if (!this.isSysRights("SupplierProductStock.findRawSupplierList")) return;
      if(batch == 'common'){
        this.batchBool = false
      }
      this.loading = true;
      let params = {
          page: this.page,
          rowsPerPage: this.rowsPerPage,
          name: this.filters.distributorName,
          contacts: this.filters.contact,
      }
      if(Object.keys(this.batchSearchParams).length !== 0 && this.batchBool){
        params = {
          batchSearch: this.batchSearchParams,
          page: this.page,
          rowsPerPage: this.rowsPerPage,
        }
      }
      $.api_call(
        "api.SupplierProductStock.findRawSupplierList",
        params,
        (r) => {
          this.loading = false;
          this.firstLoading = false;
          if (r.ErrorCode == "9999") {
            if(Object.keys(this.batchSearchParams).length !== 0){
              this.batchSearchDialog.visible = false
            }
            this.items = [];
            r.Data.Results.forEach((e) => {
              e.checked = false;
              this.items.push(e);
            });
            this.totalPage = r.Data.Pagination.totalPage;
            this.totalCount = r.Data.Pagination.totalCount;
          } else {
            if (r.ErrorCode == "1002") {
              userFailure(vm);
            } else {
              ShowTip(r.Message, "danger");
            }
          }
        }
      );
    },
    changeRPPage(num) {
      let page = this.page;
      this.rowsPerPage = num;
      this.page = 1;
      this.$router.replace({ path: "/material-suppliers/" + 1 });
      if (page == 1) {
        this.getDistributor();
      }
      this.checkArr = [];
    },
    toPage(num) {
      let page = this.page;
      this.$router.replace({ path: "/material-suppliers/" + num });
      if (page == num) {
        this.getDistributor('common');
      }
      this.checkArr = [];
    },
    gotoPage() {
      this.page = this.$route.params.page ? this.$route.params.page : 1;
      this.getDistributor();
      this.checkArr = [];
    },
    // 筛选
    filtrate(name, keyContact) {
      this.filters.distributorName = name;
      this.filters.contact = keyContact;
      //筛选都回第一页
      this.toPage(1);
    },
    clearKey(type) {
      switch (type) {
        case "name":
          this.filters.distributorName = "";
          break;
        case "batchBool":
          this.getDistributor('common');
          break;
        case "contact":
          this.filters.contact = "";
          break;
      }
      this.toPage(1);
    },
  },
};
</script>